import { Link } from 'react-router-dom';
import CTAButton from '../../components/CTAButton';
import Hero from '../../components/Hero/Hero';
import styles from './Compliance.module.scss';

const Compliance = () => {
    const complianceData = [
        {
            title: 'Código de Ética',
            description:
                'Diretrizes fundamentais de conduta ética da Decatron para todos os colaboradores e parceiros.',
            filename: 'CODIGO_DE_ETICA_2025.pdf',
        },
        {
            title: 'Código de Conduta',
            description:
                'Normas de comportamento profissional e padrões esperados no ambiente corporativo.',
            filename: 'CODIGO_DE_CONDUTA_2025.pdf',
        },
        {
            title: 'Manual Anticorrupção',
            description:
                'Políticas e procedimentos para prevenção e combate à corrupção em todas as operações.',
            filename: 'MANUAL_ANTICORRUPCAO_2025.pdf',
        },
        {
            title: 'Política de Direitos Humanos',
            description:
                'Compromisso da Decatron com o respeito e proteção dos direitos humanos universais.',
            filename: 'POLITICA_DIREITOS_HUMANOS_2025.pdf',
        },
        {
            title: 'Política Trabalho Infantil',
            description:
                'Diretrizes rigorosas contra trabalho infantil ou análogo à escravidão na cadeia de valor.',
            filename: 'POLITICA_TRABALHO_INFANTIL_2025.pdf',
        },
    ];

    // 24/09/2025
    const certificateData = [{ title: 'Certigov', img: 'certigov_seal.png' }];

    return (
        <div className={styles.container}>
            <section className={styles.banner}>
                <h1>Compliance</h1>
                <p className={styles.subtitle}>
                    Ética, transparência e responsabilidade em todos os nossos processos
                </p>
            </section>

            <main className={styles.content}>
                {/* Seção Introdução */}
                <section className={styles.intro_section}>
                    <h2>Ética e Transparência</h2>
                    <p>
                        Nosso compromisso com a ética e compliance é fundamental para construir
                        relacionamentos sólidos e duradouros com nossos clientes, parceiros e
                        colaboradores. Acreditamos que a integridade é a base de todas as nossas
                        operações.
                    </p>

                    <section className={styles.hero_section}>
                        <Hero
                            title="Canal de Denúncias"
                            description="Denuncie de forma segura e confidencial qualquer situação que viole nossos
                princípios éticos"
                            customClass={styles.customCardHero}
                        >
                            <CTAButton
                                variant="primary"
                                size="sm"
                                className={styles.ctaBtn}
                                href="https://contatoseguro.com.br/decatron"
                                target="_blank"
                            >
                                Faça sua Denúncia
                            </CTAButton>
                        </Hero>

                        <Hero
                            title="Ouvidoria"
                            description="Entre em contato, caso queira fazer uma reclamação, sugestão, solicitação ou elogio."
                            customClass={styles.customCardHero}
                        >
                            <CTAButton
                                variant="primary"
                                size="sm"
                                className={styles.ctaBtn}
                                href="/contato"
                            >
                                Entre em Contato
                            </CTAButton>
                        </Hero>
                    </section>
                </section>

                {/* Seção Documentos */}
                <section className={styles.documents_section}>
                    <h2>Documentos de Compliance</h2>
                    <p className={styles.section_description}>
                        Acesse nossos documentos oficiais de ética, compliance e políticas
                        corporativas
                    </p>

                    <div className={styles.documents_grid}>
                        {complianceData.map((item, index) => (
                            <article key={index} className={styles.document_card}>
                                <a
                                    className={styles.download_link}
                                    href={`/assets/documents/${item.filename}`}
                                    target="_blank"
                                    rel="noreferrer"
                                    aria-label={`Baixar documento: ${item.title}`}
                                >
                                    <div className={styles.card_header}>
                                        <div className={styles.card_icon} aria-hidden="true"></div>
                                        <span className={styles.download_label}>
                                            Clique para baixar PDF
                                        </span>
                                    </div>
                                    <h3>{item.title}</h3>
                                    <p>{item.description}</p>
                                </a>
                            </article>
                        ))}
                    </div>
                </section>

                <section className={styles.seals_section}>
                    <h2>Empresa certificada </h2>
                    <p className={styles.section_description}>
                        Empresa com certificado em vendas ao governo com credibilidade.
                    </p>
                    <p className={styles.cert_description}>
                        Para validar o certificado da Decatron no site da Certigov,
                        <strong>clique na imagem abaixo.</strong> <br />e utilize o código{' '}
                        <strong>OPNV0OF26LV</strong>
                    </p>

                    <div className={styles.seals_grid}>
                        {certificateData.map((seal, index) => (
                            <article className={styles.seals_container}>
                                <Link
                                    key={index}
                                    className={styles.seal_container}
                                    to="https://certigov.com.br/validacao"
                                    target="_blank"
                                >
                                    <img
                                        src={`/assets/seals/${seal.img}`}
                                        alt={`Selo ${seal.title}`}
                                    />
                                </Link>
                            </article>
                        ))}
                    </div>
                </section>
            </main>
        </div>
    );
};

export default Compliance;
